import { generateTestId } from "@client-shared";

export const setMapProductsStepTestId = (identifier: string): string => generateTestId("MapProductsStep", identifier);
